import { useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import errorStateImage from '@/assets/img/error-state.png';
import { trackNotFoundPageViewed } from '@/features/analytics/track/trackNotFoundPageViewed';
import { Button } from '@/shared/components/ui/button';

export function DefaultNotFoundComponent() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    trackNotFoundPageViewed(location.pathname);
  }, [location.pathname]);

  const handleGoToMainPage = () => {
    void navigate({ to: '/' });
  };

  return (
    <div className="min-h-screen-safe flex w-full flex-col items-center justify-center px-5">
      <div className="flex w-full max-w-md flex-col items-center gap-5">
        <div className="relative size-50 shrink-0 overflow-hidden rounded-full">
          <img
            src={errorStateImage}
            alt="Page not found illustration"
            className="size-full object-cover"
          />
        </div>

        <div className="flex w-full flex-col items-center gap-2">
          <h1 className="text-center text-2xl leading-none font-extrabold text-white">
            Page not found
          </h1>
          <p className="text-cold-400 text-center text-sm font-medium">
            This page doesn't exist.
          </p>
        </div>

        <div className="flex w-full items-center justify-center">
          <Button onClick={handleGoToMainPage}>Go to main page</Button>
        </div>
      </div>
    </div>
  );
}
